import { connect, useDispatch } from 'react-redux';

import { coreHideNotices } from '../actions/coreActions';
import { NoticeTypesEnum } from '../enums/NoticeTypesEnum';
import { IRootState } from '../interfaces/IRootState';
import { Notice } from './Notices';

interface INotifierStoreProps {
  noticeType?: NoticeTypesEnum;
  notice?: string;
  isShowNotice?: boolean;
}

const NotifierWithoutStore = ({ notice, noticeType, isShowNotice }: INotifierStoreProps) => {
  const dispatch = useDispatch();

  const onClose = () => dispatch(coreHideNotices());

  return isShowNotice ? <Notice notice={notice} noticeType={noticeType} onClose={onClose} /> : null;
};

const mapStateToProps = (state: IRootState): INotifierStoreProps => ({
  noticeType: state.core.noticeType,
  notice: state.core.notice,
  isShowNotice: state.core.isShowNotice,
});

export const Notifier = connect(mapStateToProps)(NotifierWithoutStore);
